var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3754 17.3608C29.5876 16.3691 29.7998 15.3775 29.7998 14.0552C29.7998 6.78301 25.9801 0.833008 21.3116 0.833008C18.1285 0.833008 15.1576 3.80801 13.8844 8.10523C13.2478 7.77467 12.399 7.44412 11.7623 7.44412C8.79147 7.44412 6.45722 11.0802 6.45722 15.708C6.45722 16.3691 6.45722 17.0302 6.66942 17.3608C2.84973 18.3525 0.0910645 22.9802 0.0910645 28.9302C0.0910645 35.2108 3.48635 40.4997 7.51824 40.4997H14.9454V30.583H8.57927L18.1285 15.708L27.6777 30.583H21.3116V40.4997H28.7387C32.7706 40.4997 36.1659 35.2108 36.1659 28.9302C36.1659 22.9802 33.195 18.0219 29.3754 17.3608Z",
    fill: "#808795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.c4ed5038c67f68f0d882d973bc718da5.svg";
export { ForwardRef as ReactComponent };